import React, { useState, useRef, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { toast } from 'react-toastify'
import Seccion from 'components/Modificaciones/Seccion'

import api from 'api/api'

function Historia() {

	// render
	return (
		<Container fluid id="seccion-contacto" className="vh-100">
			<Row>
				<Col className="mt-2">
					<h1>Contenido de la sección "Contacto"</h1>
					<hr />
					<Seccion
						nombreSeccion="contacto"
					/>
				</Col>
			</Row>
		</Container>
	)
}

export default Historia